module.exports = __webpack_public_path__ + "e5188fb92a7a4c7b7bdf612ca8877063.svg";